export default "__VITE_ASSET__2g0QElJa__"